
import { Component, Mixins } from 'vue-property-decorator';
import AdvisorStudentBenefitsVouchers from '../../advisorSystem/widgets/StudentBenefitsVouchers.vue';
@Component({})
export default class StudentBenefitsVouchers extends Mixins(AdvisorStudentBenefitsVouchers) {}
